<template>
  <div class="footer_warp">
    <div class="footer flex">
      <div class="footer_info flex">
        <p>Copyright@2022 宝鸡市扶风县图书馆版权所有</p>
        <p>
          技术支持：西安鼎浩科技有限公司   &emsp;  访问量：{{ visitNum }}
        </p>

      </div>
      <img class="footer_icon" src="@/assets/img/common/dinghao_icon.png" alt="" />
    </div>
  </div>
</template>

<script>
import {visit } from '@/api/index.js'
export default {
  data(){
    return {

        visitNum:0
    }
  },
  mounted() {
    this.visit()
  },
  methods:{
    async visit(){
      const res = await visit()
      this.visitNum =res
      // console.log(res,1111111111)
    },
  }
}
</script>

<style lang="less" scoped>
.footer_warp {
  width: 100%;
  height: 85px;
  background: #e9e1d7;
  letter-spacing: 2px;
  .footer {
    height: 100%;
    font-size: 14px;
    color: #666;
    p {
      margin: 8px 0;
    }
  }
  .footer_info {
    flex-direction: column;
    margin-right: 80px;
  }
}
</style>
